import type { FaireProductEntity } from "../../entity_types/product";

export const p_ggp73rpu8d: FaireProductEntity = {
  token: "p_ggp73rpu8d",
  type: "product",
  name: "Short Lace Corset Formal Dress",
  brandToken: "b_av43xzgdd9",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/850bee103f722b322ffa22d06808495bfd5074b88f0c5829855004efc66be86a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b2ef8c81d5d5a297fe3586216de4b46476ad8e96d88010542fc2aba66e852c40.jpeg",
    "https://cdn.faire.com/fastly/5321a568b459538fad2c6bbdf857d4cc8d531c5f27c1a94385d931491b50444c.jpeg",
    "https://cdn.faire.com/fastly/f3daf7a078f2b4043d1ee536078a43f5db01bc24a1fa4610c3a13414f8bd05a3.jpeg",
    "https://cdn.faire.com/fastly/bb89c4e7b0bd160b961960f84917d1003b6809f1884bfc3bd10618e3402f5b8a.jpeg",
  ],
  priceDollars: 109.47,
  description:
    "This short formal dress is designed to highlight the waist and neckline with a structured, figure focused silhouette. The corset style bodice features visible boning that provides shape and support while creating a defined hourglass look. A sweetheart neckline softens the structured bodice and frames the bust naturally. Lace overlay as texture and depth without overwhelming the design. The fitted skirt follows the body closely, keeping the look sleek and modern. This style works well for cocktail events, evening parties, and occasions where a confident, tailored look is preferred.\n\nSilhouette & Fit: Fitted mini dress with corset bodice\nNeckline & Sleeves: Sweetheart neckline, strapless\nLength: Short\nFabric (Shell): Lace overlay with mesh corset bodice\nLining: Fully lined\nStructure: Corset boning\nStretch: Minimal stretch\nClosure: Back zipper\nBack: Straight back\nHem: Short hem\nSlit: None\nPockets: None\nEmbellishment: Lace overlay, corset boning\nColor: Black\nSizes: 4, 6, 8, 10, 12, 14, 16\nModel Notes: Model is 5'9\"\nOccasions: Cocktail events, evening parties, special occasions\nCare: Dry clean only",
  tags: [],
  msrpDollars: 218.94,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:42.670Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
